import {
    Population,
    SELECTED_ITEM_ALL_ID,
} from '../../../user/population-select';
import { Parameters } from '../../backend';
import { ParametersView } from '../model/parameters-view.model';

export function createParamsView(bp: Parameters): ParametersView {
    const vp: ParametersView = {};

    vp.dataSource = bp.dataSource;
    vp.periodType = {
        id: bp.periodType?.id,
    };
    vp.cacheDate = {
        periodType: bp.periodType?.id,
        startDate: null,
        endDate: bp.endDate,
        eventDate: null,
    };
    vp.rawStartDate = bp.startDate;
    vp.rawEndDate = bp.endDate;
    vp.reportType = bp.reportType;
    vp.role = bp.roles?.map((e) => {
        return {
            population: Population.Role,
            id: e.id,
            label: null,
        };
    });
    vp.team = bp.teams?.map((e) => {
        return {
            population: Population.User,
            id: e.id,
            label: null,
        };
    });
    vp.individual = bp.individuals?.map((e) => {
        return {
            population: Population.User,
            id: e.id,
            label: null,
        };
    });
    vp.site = bp.sites?.map((e) => {
        return {
            population: Population.Site,
            id: e.id === -1 ? SELECTED_ITEM_ALL_ID : e.id,
            label: null,
        };
    });
    vp.dataDimension = bp.dataDimension;
    vp.superGroup = bp.superGroups?.map((e) => {
        return {
            population: Population.SuperGroup,
            id: e.id,
            label: null,
        };
    });
    vp.queue = bp.queues?.map((e) => {
        return {
            population: Population.Queue,
            id: e.id === -1 ? SELECTED_ITEM_ALL_ID : e.id,
            label: null,
        };
    });
    vp.metrics = bp.metrics?.map((e) => {
        return {
            id: e.id,
        };
    });

    return vp;
}
